import React, { Component } from "react";

import Review from "./Review";

import "../css/Reviews.css";

class Reviews extends Component {
  constructor(props) {
    super(props);

    this.state = { stars: [], halfStars: [], googleInfo: {} };

    // Places.apiKey = GOOGLE_API_KEY;
    // Places.debug = true; // boolean;
    this.renderReviews = this.renderReviews.bind(this);
  }

  renderReviews() {
    let reviews = this.props.place && this.props.place.reviews;

    return reviews
      ? reviews
          .filter((rev) => rev.rating > 4)
          .map((review, idx) => {
            if (review.text)
              return (
                <Review
                  key={idx}
                  text={review.text}
                  reviewer={review.author_name}
                  rating={review.rating}
                />
              );
            return null;
          })
      : null;
  }

  render() {
    return <div className='rating'>{this.renderReviews()}</div>;
  }
}

export default Reviews;



// WEBPACK FOOTER //
// ./src/components/Reviews.jsx